import { ObjectElement } from '@swagger-api/apidom-core';

/**
 * @public
 */
class ComponentsMediaTypes extends ObjectElement {
  static primaryClass = 'components-media-types';
  constructor(content, meta, attributes) {
    super(content, meta, attributes);
    this.classes.push(ComponentsMediaTypes.primaryClass);
  }
}
export default ComponentsMediaTypes;